module.exports = __webpack_public_path__ + "static/media/kt_white.c5a6a94a.svg";